import { createSelector } from '@reduxjs/toolkit';
import { selectMortgagePromoSearchTypeValue } from './selectMortgagePromoSearchTypeValue';
import { selectMortgagePromoSearchTypeOptions } from './selectMortgagePromoSearchTypeOptions';
import { IConfig } from '@cian/config/shared';

export const selectMortgagePromoSearchTypeFilter = (config: IConfig) => {
  const mortgagePromoSearchTypeOptionsSelector = selectMortgagePromoSearchTypeOptions(config);

  return createSelector(
    [selectMortgagePromoSearchTypeValue, mortgagePromoSearchTypeOptionsSelector],
    (value, options) => ({
      label: 'Ипотечные программы',
      value,
      options,
    }),
  );
};
